// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"354140b6","213":"f1541ebe","667":"3f0ccf93","777":"730e68b0"}[chunkId] + ".chunk.js";
};